export const normalizeProductCode = (value?: string | null): string =>
  (value ?? '').trim().toLowerCase();

type ProductCodeFields = {
  sku?: string;
  id?: string;
  barcode?: string;
};

export const isExactProductCode = (query: string, product: ProductCodeFields): boolean => {
  const q = normalizeProductCode(query);
  if (!q) return false;
  return [product.sku, product.id, product.barcode].some((value) => normalizeProductCode(value) === q);
};

export const findExactProductMatch = <T extends ProductCodeFields>(query: string, products: T[]): T | undefined =>
  products.find((product) => isExactProductCode(query, product));
